// Función para manejar el datepicker con cutoff para Shared Tours
$(document).on('turbolinks:load', function() {
  if ($('#tourDateSelect').length > 0) {
    initializeSharedTourDatepicker();
  }
});

function initializeSharedTourDatepicker() {
  const $dateInput = $('#tourDateSelect');
  
  if (!$dateInput.length) return;
  
  // Función helper para parsear JSON de forma segura
  function safeJsonParse(data, defaultValue = []) {
    if (!data || data === '' || data === 'undefined') {
      return defaultValue;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      console.warn('Error parsing JSON:', data, e);
      return defaultValue;
    }
  }
  
  // Obtener datos del campo con parsing seguro
  const cutoffHours = parseInt($dateInput.data('cutoff-hours') || 0);
  const blockedDatesByCutoff = safeJsonParse($dateInput.data('blocked-dates-cutoff'), []);
  const disabledDates = safeJsonParse($dateInput.data('disabled-dates'), []);
  const tourTimes = safeJsonParse($dateInput.data('tour-times'), []);
  const tourId = $dateInput.data('tour-id');
  
  console.log('Cutoff Hours:', cutoffHours);
  console.log('Blocked Dates by Cutoff:', blockedDatesByCutoff);
  console.log('Disabled Dates from Calendar:', disabledDates);
  console.log('Tour Times:', tourTimes);
  console.log('Tour ID:', tourId);
  
  // Función para calcular fechas bloqueadas por cutoff dinámicamente
  function calculateBlockedDatesByCutoff() {
    if (cutoffHours === 0) return [];
    
    const blockedDates = [];
    const now = new Date();
    
    // Revisar los próximos 7 días
    for (let i = 0; i < 7; i++) {
      const checkDate = new Date();
      checkDate.setDate(now.getDate() + i);
      
      // Usar las horas reales del tour obtenidas del servidor
      
      let isDateBlocked = false;
      
      for (const tourTime of tourTimes) {
        const [hours, minutes] = tourTime.split(':');
        const tourDateTime = new Date(checkDate);
        tourDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
        
        // Calcular diferencia en horas
        const hoursUntilTour = (tourDateTime - now) / (1000 * 60 * 60);
        
        if (hoursUntilTour < cutoffHours) {
          isDateBlocked = true;
          break;
        }
      }
      
      if (isDateBlocked) {
        const dateStr = checkDate.getFullYear() + '-' + 
                        String(checkDate.getMonth() + 1).padStart(2, '0') + '-' + 
                        String(checkDate.getDate()).padStart(2, '0');
        blockedDates.push(dateStr);
      }
    }
    
    return blockedDates;
  }
  
  // Combinar todas las fechas deshabilitadas
  const dynamicBlockedDates = calculateBlockedDatesByCutoff();
  const allDisabledDates = [...new Set([...disabledDates, ...blockedDatesByCutoff, ...dynamicBlockedDates])];
  
  console.log('All Disabled Dates:', allDisabledDates);
  
  // Destruir instancia previa si existe
  if ($dateInput.data('datepicker')) {
    $dateInput.datepicker('destroy');
  }
  
  // Inicializar datepicker con fechas deshabilitadas
  $dateInput.datepicker({
    format: 'yyyy-mm-dd',
    todayHighlight: true,
    autoclose: true,
    startDate: new Date(),
    container: 'body',
    orientation: 'bottom auto',
    beforeShowDay: function(date) {
      const dateStr = date.getFullYear() + '-' + 
                      String(date.getMonth() + 1).padStart(2, '0') + '-' + 
                      String(date.getDate()).padStart(2, '0');
      
      // Verificar si la fecha está deshabilitada
      if (allDisabledDates.includes(dateStr)) {
        return {
          enabled: false,
          classes: 'disabled-by-cutoff',
          tooltip: cutoffHours > 0 ? 
            `Bookings must be made at least ${cutoffHours} hours in advance` : 
            'Date not available'
        };
      }
      
      // Verificar si es una fecha pasada
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      
      if (date < today) {
        return {
          enabled: false,
          classes: 'disabled-past-date',
          tooltip: 'Past date'
        };
      }
      
      return {
        enabled: true
      };
    }
  }).on('changeDate', function(e) {
    console.log('Date selected:', e.format());
    
    // Actualizar las horas disponibles cuando se selecciona una fecha
    updateAvailableTimesForDate(e.date);
  });
}

// Función para actualizar las horas disponibles basadas en el cutoff
function updateAvailableTimesForDate(selectedDate) {
  const $dateInput = $('#tourDateSelect');
  const $timeSelect = $('#tourTimeSelect');
  const cutoffHours = parseInt($dateInput.data('cutoff-hours') || 0);
  const $messageText = $('#noTimesMessageText');
  
  if (cutoffHours === 0 || !$timeSelect.length) return;
  
  // Hacer llamada AJAX para obtener las horas disponibles
  const dateStr = selectedDate.getFullYear() + '-' + 
                  String(selectedDate.getMonth() + 1).padStart(2, '0') + '-' + 
                  String(selectedDate.getDate()).padStart(2, '0');
  
  // Actualizar el mensaje con información más específica
  if ($messageText.length) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    
    if (selectedDate.getTime() === today.getTime()) {
      // Es hoy - mensaje específico
      const currentLang = $('html').attr('lang') || 'en';
      if (currentLang === 'es') {
        $messageText.html(`<strong>No hay horarios disponibles para hoy.</strong><br>Los tours deben reservarse con al menos ${cutoffHours} horas de anticipación.`);
      } else {
        $messageText.html(`<strong>No times available for today.</strong><br>Tours must be booked at least ${cutoffHours} hours in advance.`);
      }
    } else {
      // Es otro día - mensaje general
      const currentLang = $('html').attr('lang') || 'en';
      if (currentLang === 'es') {
        $messageText.html(`<strong>No hay horarios disponibles para esta fecha.</strong><br>Es posible que todos los horarios estén dentro del período de corte de ${cutoffHours} horas.`);
      } else {
        $messageText.html(`<strong>No times available for this date.</strong><br>All times may be within the ${cutoffHours}-hour cutoff period.`);
      }
    }
  }
  
  // Esta función es complementaria al AJAX, no reemplaza la funcionalidad principal
  // El AJAX en _book_shared.html.erb ya maneja la actualización del select
}

// Agregar estilos CSS para fechas deshabilitadas por cutoff
const style = document.createElement('style');
style.textContent = `
  .datepicker .disabled-by-cutoff {
    background-color: #ffebee !important;
    color: #c62828 !important;
    text-decoration: line-through;
    cursor: not-allowed !important;
  }
  
  .datepicker .disabled-past-date {
    background-color: #f5f5f5 !important;
    color: #9e9e9e !important;
    cursor: not-allowed !important;
  }
`;
document.head.appendChild(style);
